import React, { Component, Fragment } from 'react';
import {
    Segment,
    Header,
    Table,
    Button,
    Icon,
    Form,
    Dimmer,
    Loader,
    Message,
    Dropdown,
    Popup,
    Confirm, Input
} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { FiltersOnStyle, HeaderCursor } from '../../Professor/ProfessorInputGrades/css';
import { Link } from 'react-router-dom';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import { IconHeader } from '../../Assets/util/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class SemesterManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            semesters: [],
            filteredSemesters: [],
            academicYears: [],
            loading: true,
            loadingOptions:true,
            showForm: false,
            editMode: false,
            confirmDelete: false,
            currentSemester: {
                id: null,
                name: null,
                academicYear: null,
                startDate: '',
                endDate: '',
                earlyEnrollmentStartDate: '',
                optLock: 0,
                courseImplementations: null,
                studentPauses: null
            },
            filters: {
                academicYear: '',
                semesterType: '',
                searchText: ''
            },
            semesterTypeOptions: [],
            errors: {},
            deletingRowId: null,
            saving: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.showForm = this.showForm.bind(this);
        this.hideForm = this.hideForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
    }

    componentDidMount() {
        // Check if user has proper role access
        if (!this.hasPermissionToManageSemesters()) {
            toast('Nemate dozvolu za pristup ovoj stranici');
            window.history.back();
            return;
        }

        this.fetchData();
    }

    fetchData() {
        this.setState({ loading: true, loadingOptions:true });
        Promise.all([
            this.fetchSemesters(),
            this.fetchAcademicYears(),
            this.fetchSemesterNames()
        ]).then(([semestersRes, academicYearsRes, semesterNamesRes]) => {
            const academicYearsData = academicYearsRes.data || [];
            const semesterTypesData = semesterNamesRes.data
                .filter(type => type.name !== 'ostalo' && type.name !== 'ljetna škola');

            const semestersData = (semestersRes.data || []).sort(this.compareSemestersByAcademicYearDesc);

            this.setState({
                semesters: semestersData,
                filteredSemesters: semestersData,
                academicYears: academicYearsData,
                semesterTypeOptions: semesterTypesData,
                loading: false,
                loadingOptions:false
            });
        }).catch(error => {
            console.error('Error fetching data:', error);
            toast('Greška pri učitavanju podataka');
            this.setState({ loading: false,loadingOptions:false });
        });
    }

    fetchSemesters() {
        return axios.get('/semester');
    }

    compareSemestersByAcademicYearDesc(a, b) {
        const aYear = a.academicYear ? (a.academicYear.startYear || a.academicYear.id) : 0;
        const bYear = b.academicYear ? (b.academicYear.startYear || b.academicYear.id) : 0;
        return bYear - aYear;
    }

    fetchAcademicYears() {
        return axios.get('/academic-years');
    }

    fetchSemesterNames() {
        return axios.get('/semester-names');
    }

    handleInputChange(event, { name, value }) {
        this.setState(prevState => ({
            currentSemester: {
                ...prevState.currentSemester,
                [name]: value
            },
            errors: {
                ...prevState.errors,
                [name]: null
            }
        }));
    }

    handleStartDateChange(date) {
        this.setState(prevState => ({
            currentSemester: {
                ...prevState.currentSemester,
                startDate: date
            }
        }));
    }

    handleEndDateChange(date) {
        this.setState(prevState => ({
            currentSemester: {
                ...prevState.currentSemester,
                endDate: date
            }
        }));
    }

    handleEarlyDateChange(date) {
        this.setState(prevState => ({
            currentSemester: {
                ...prevState.currentSemester,
                earlyEnrollmentStartDate: date
            }
        }));
    }

    // Format dates for HTML input (YYYY-MM-DD)
    formatDateForInput = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toISOString().split('T')[0];
    };

    semesterToCurrentSemester(semester) {
        return {
            id: semester.id,
            name: semester.name || null,
            academicYear: semester.academicYear || null,
            startDate: this.formatDateForInput(semester.startDate),
            endDate: this.formatDateForInput(semester.endDate),
            earlyEnrollmentStartDate: this.formatDateForInput(semester.earlyEnrollmentStartDate),
            optLock: semester.optLock || 0,
            courseImplementations: semester.courseImplementations || null,
            studentPauses: semester.studentPauses || null
        }
    }

    handleFilterChange(event, { name, value }) {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }), this.applyFilters);
    }

    applyFilters() {
        const { semesters, filters } = this.state;
        let filtered = [...semesters];

        if (filters.academicYear) {
            filtered = filtered.filter(semester =>
                semester.academicYear && semester.academicYear.id === filters.academicYear
            );
        }

        if (filters.semesterType) {
            filtered = filtered.filter(semester =>
                semester.name && semester.name._key === filters.semesterType
            );
        }

        if (filters.searchText) {
            const searchLower = filters.searchText.toLowerCase();
            filtered = filtered.filter(semester =>
                (semester.academicYear && semester.academicYear.name.toLowerCase().includes(searchLower)) ||
                (semester.name && semester.name.name.toLowerCase().includes(searchLower))
            );
        }

        filtered.sort(this.compareSemestersByAcademicYearDesc);

        this.setState({ filteredSemesters: filtered });
    }

    showForm(editMode = false, semester = null) {
        if (editMode && semester) {
            // Debug: log the semester object to see its structure
            console.log('Edit semester data:', semester);

            const currentSemesterData = this.semesterToCurrentSemester(semester);

            console.log('Mapped currentSemester data:', currentSemesterData);

            this.setState({
                showForm: true,
                editMode: true,
                currentSemester: currentSemesterData
            });
        } else {
            this.setState({
                showForm: true,
                editMode: false,
                currentSemester: {
                    id: null,
                    name: null,
                    academicYear: null,
                    startDate: '',
                    endDate: '',
                    earlyEnrollmentStartDate: '',
                    optLock: 0
                }
            });
        }
    }

    hideForm() {
        this.setState({
            showForm: false,
            editMode: false,
            errors: {},
            currentSemester: {
                id: null,
                name: null,
                academicYear: null,
                startDate: '',
                endDate: '',
                earlyEnrollmentStartDate: '',
                optLock: 0
            }
        });
    }

    validateForm() {
        const { currentSemester } = this.state;
        const errors = this.validateSemesterData(currentSemester);
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    handleSubmit() {
        // Check role permission before submitting
        if (!this.hasPermissionToManageSemesters()) {
            toast('Nemate dozvolu za ovu akciju');
            return;
        }

        if (!this.validateForm()) {
            return;
        }

        const { currentSemester, editMode } = this.state;

        // Convert dates to unix timestamps
        const convertDateToTimestamp = (dateString) => {
            if (!dateString) return null;
            return new Date(dateString).getTime();
        };

        const semesterData = {
            id: currentSemester.id,
            academicYear: currentSemester.academicYear,
            name: currentSemester.name,
            startDate: convertDateToTimestamp(currentSemester.startDate),
            endDate: convertDateToTimestamp(currentSemester.endDate),
            earlyEnrollmentStartDate: convertDateToTimestamp(currentSemester.earlyEnrollmentStartDate),
            optLock: currentSemester.optLock,
            courseImplementations: currentSemester.courseImplementations || null,
            studentPauses: currentSemester.studentPauses || null
        };

        const request = editMode
            ? axios.put(`/semester/edit`, semesterData)
            : axios.post('/semester', semesterData);

        request.then(() => {
            toast(editMode ? 'Semestar je uspješno ažuriran' : 'Semestar je uspješno kreiran');
            this.hideForm();
            this.fetchData();
        }).catch(error => {
            console.error('Error saving semester:', error);
            if (error.response && error.response.data) {
                toast(`Došlo do je greške`);
            } else {
                toast('Greška pri spašavanju semestra');
            }
        });
    }

    handleEdit(semester) {
        this.showForm(true, semester);
    }

    handleDelete(id) {
        this.setState({
            deletingRowId: id,
            confirmDelete: true
        });
    }

    confirmDelete() {
        if (!this.hasPermissionToManageSemesters()) {
            toast('Nemate dozvolu za ovu akciju');
            return;
        }
        const { deletingRowId } = this.state;
        axios.delete(`/semester/delete/${deletingRowId}`).then(() => {
            toast('Semestar je uspješno obrisan');
            this.setState({
                confirmDelete: false,
                deletingRowId: null
            });
            this.fetchData();
        }).catch(error => {
            console.error('Error deleting semester:', error);
            if (error.response && error.response.data) {
                toast(`Došlo je do greške`);
            } else {
                toast('Greška pri brisanju semestra');
            }
            this.setState({
                confirmDelete: false,
                deletingRowId: null
            });
        });
    }

    cancelDelete() {
        this.setState({
            confirmDelete: false,
            deletingRowId: null
        });
    }

    render() {
        const {
            filteredSemesters,
            academicYears,
            loading,
            showForm,
            editMode,
            currentSemester,
            filters,
            semesterTypeOptions,
            errors,
            confirmDelete,
            deletingRowId,
            saving,
            loadingOptions
        } = this.state;

        // Check if user has proper role access
        const hasAccess = this.hasPermissionToManageSemesters();

        if (!hasAccess) {
            return (
                <Segment>
                    <Message negative>
                        <Message.Header>Nemate dozvolu</Message.Header>
                        <p>Nemate dozvolu za pristup ovoj stranici. Samo administratori i AIDA mogu upravljati semestrima.</p>
                    </Message>
                </Segment>
            );
        }

        return (
            <div>
                <Header as="h1">Semestri</Header>
                <Segment.Group raised>
                    <Segment>
                            <Header as="h3">
                                Pregled semestara
                                    <Header style={IconHeader} floated="right">
                                        <Button
                                            primary
                                            color="green"
                                            floated="right"
                                            icon
                                            labelPosition="right"
                                            size="small"
                                            style={FiltersOnStyle}
                                            onClick={() => this.setState({
                                                showForm: true,
                                                editingRowData: null
                                            })}
                                        >
                                            <Icon className="add"/>
                                            Kreirajte novi semestar
                                        </Button>
                                    </Header>


                            </Header>

                    </Segment>

                    {/* Create/Edit Form */}
                    {showForm && (
                        <Segment clearing>
                            {
                                loadingOptions ? (
                                        <div style={{
                                            paddingTop: '100px',
                                            paddingBottom: '100px'
                                        }}><Loader active inline="centered"/></div>
                                    ) :

                                    (
                                        <Form>
                                            <Form.Group widths={'equal'}>

                                                <Form.Field required>
                                                    <label>{<FormattedMessage id="semesterManagement.academicYear"/>}</label>
                                                    <Dropdown
                                                        placeholder={<FormattedMessage id="semesterManagement.selectAcademicYear"/>}
                                                        selection
                                                        options={this.getAcademicYearDropdownOptions()}
                                                        value={currentSemester.academicYear ? currentSemester.academicYear.id : null}
                                                        onChange={(e, { value }) => {
                                                            const selectedYear = academicYears.find(year => year.id === value);
                                                            this.handleInputChange(e, {
                                                                name: 'academicYear',
                                                                value: selectedYear || null
                                                            });
                                                        }}
                                                    />
                                                </Form.Field>
                                                <Form.Field required>
                                                    <label>{<FormattedMessage id="semesterManagement.semesterType"/>}</label>
                                                    <Dropdown
                                                        placeholder={<FormattedMessage id="semesterManagement.semesterTypeSelect"/>}
                                                        selection
                                                        options={this.getSemesterTypeDropdownOptions()}
                                                        value={currentSemester.name ? currentSemester.name._key : null}
                                                        onChange={(e, { value }) => {
                                                            const selectedType = semesterTypeOptions.find(type => type._key === value);
                                                            this.handleInputChange(e, {
                                                                name: 'name',
                                                                value: selectedType || null
                                                            });
                                                        }}
                                                    />
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group widths="equal">

                                                <Fragment>
                                                    <Form.Field required>
                                                        <label>{<FormattedMessage id="semesterManagement.semesterStartDate"/>}</label>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            value={currentSemester.startDate ? new Date(currentSemester.startDate) : null}
                                                            onChange={(value) => this.handleStartDateChange(value)}
                                                        />
                                                    </Form.Field>
                                                </Fragment>



                                                <Fragment>
                                                    <Form.Field required>
                                                        <label>{<FormattedMessage id="semesterManagement.semesterEndDate"/>}</label>
                                                        <DateTimePicker
                                                            format="D. M. YYYY."
                                                            time={false}
                                                            value={currentSemester.endDate ? new Date(currentSemester.endDate) : null}
                                                            onChange={(value) => this.handleEndDateChange(value)}
                                                        />
                                                    </Form.Field>
                                                </Fragment>


                                            </Form.Group>




                                            <Fragment>
                                                <Form.Field>
                                                    <label>{<FormattedMessage id="semesterManagement.startDateOfEarlyEnrollment"/>}</label>
                                                    <DateTimePicker
                                                        format="D. M. YYYY."
                                                        time={false}
                                                        value={currentSemester.earlyEnrollmentStartDate ? new Date(currentSemester.earlyEnrollmentStartDate) : null}
                                                        onChange={(value) => this.handleEarlyDateChange(value)}
                                                    />
                                                </Form.Field>
                                            </Fragment>




                                            <Button floated={'right'} basic color="blue" disabled={saving} onClick={this.hideForm}>
                                                Odustani
                                            </Button>
                                            <Button floated={'right'} color="blue" onClick={this.handleSubmit} loading={saving}>
                                                Potvrdi
                                            </Button>


                                        </Form>
                                    )
                            }
                        </Segment>
                    )}

                    {/* Filters */}
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Akademska godina</label>
                                    <Dropdown
                                        placeholder="Sve akademske godine"
                                        clearable
                                        selection
                                        options={this.getAcademicYearDropdownOptions()}
                                        value={filters.academicYear}
                                        onChange={this.handleFilterChange}
                                        name="academicYear"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Tip semestra</label>
                                    <Dropdown
                                        placeholder="Svi tipovi"
                                        clearable
                                        selection
                                        options={this.getSemesterTypeDropdownOptions()}
                                        value={filters.semesterType}
                                        onChange={this.handleFilterChange}
                                        name="semesterType"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Pretraga</label>
                                    <Form.Input
                                        placeholder="Pretražite semestre..."
                                        value={filters.searchText}
                                        onChange={(e, { value }) => this.handleFilterChange(e, { name: 'searchText', value })}
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Form>
                    </Segment>


                    <Segment>
                        {!loading ?
                            <div>

                                { filteredSemesters.length ?
                                    <Table celled>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>Akademska godina</Table.HeaderCell>
                                                <Table.HeaderCell>Tip semestra</Table.HeaderCell>
                                                <Table.HeaderCell>Datum početka</Table.HeaderCell>
                                                <Table.HeaderCell>Datum završetka</Table.HeaderCell>
                                                <Table.HeaderCell>Datum prijevremenog upisa</Table.HeaderCell>
                                                <Table.HeaderCell width={3}></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {filteredSemesters.map((semester) => (
                                                <Table.Row key={semester.id}>
                                                    <Table.Cell  verticalAlign={'middle'} >
                                                        {semester.academicYear ? semester.academicYear.name : ''}
                                                    </Table.Cell>
                                                    <Table.Cell  verticalAlign={'middle'} >
                                                        {semester.name ? this.formatSemesterType(semester.name.name) : ''}
                                                    </Table.Cell>
                                                    <Table.Cell  verticalAlign={'middle'} >
                                                        {this.formatDate(semester.startDate)}
                                                    </Table.Cell>
                                                    <Table.Cell  verticalAlign={'middle'} >
                                                        {this.formatDate(semester.endDate)}
                                                    </Table.Cell>
                                                    <Table.Cell  verticalAlign={'middle'} >
                                                        {this.formatDate(semester.earlyEnrollmentStartDate)}
                                                    </Table.Cell>
                                                    <Table.Cell  textAlign={'center'} verticalAlign={'middle'} >
                                                        {
                                                            (deletingRowId === semester.id) ? (
                                                                <Fragment>
                                                                    <Popup
                                                                        content="Obriši semestar"
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="blue"
                                                                            onClick={this.confirmDelete}
                                                                            disabled={saving}
                                                                            loading={saving}
                                                                        >
                                                                            <Icon name="check"/>
                                                                        </Button>}/>
                                                                    <Popup
                                                                        content="Odustani"
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            basic
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="blue"
                                                                            onClick={() => this.setState({ deletingRowId: null })}
                                                                            disabled={saving}
                                                                        >
                                                                            <Icon name="close"/>
                                                                        </Button>}/>
                                                                </Fragment>
                                                            ) : (
                                                                <Fragment>
                                                                    <Popup
                                                                        content="Uredi semestar"
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            basic
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="green"
                                                                            disabled={showForm || deletingRowId}
                                                                            onClick={() => this.setState({
                                                                                showForm: true,
                                                                                editMode: true,
                                                                                currentSemester: this.semesterToCurrentSemester(semester)
                                                                            })}
                                                                        >
                                                                            <Icon name="pencil"/>
                                                                        </Button>}
                                                                    />
                                                                    <Popup
                                                                        content="Obriši semestar"
                                                                        position="top center"
                                                                        trigger={<Button
                                                                            basic
                                                                            circular
                                                                            icon
                                                                            size="tiny"
                                                                            color="red"
                                                                            disabled={showForm || deletingRowId}
                                                                            onClick={() => {
                                                                                this.setState({ deletingRowId: semester.id });
                                                                            }}
                                                                        >
                                                                            <Icon name="trash alternate"/>
                                                                        </Button>}
                                                                    />
                                                                </Fragment>
                                                            )}
                                                    </Table.Cell>
                                                </Table.Row>
                                            ))}
                                        </Table.Body>
                                    </Table>
                                    :  'Nema studenata.'}
                            </div>
                            : <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> }

                    </Segment>

                </Segment.Group>








                {/* Semesters Table */}

                {/* Delete Confirmation */}
                <Confirm
                    open={confirmDelete}
                    header="Potvrda brisanja"
                    content="Da li ste sigurni da želite obrisati ovaj semestar? Ova akcija se ne može poništiti."
                    confirmButton="Da, obriši"
                    cancelButton="Odustani"
                    center
                    onCancel={this.cancelDelete}
                    onConfirm={this.confirmDelete}
                />

                <ToastContainer  hideProgressBar />
            </div>
        );
    }

    hasPermissionToManageSemesters() {
        const activeRole = localStorage.getItem('activeRole');
        return activeRole === 'Administrator' || activeRole === 'AIDA';
    }

    validateSemesterData(semesterData) {
        const errors = {};

        if (!semesterData.academicYear) {
            errors.academicYear = 'Akademska godina je obavezna';
        }

        if (!semesterData.name) {
            errors.name = 'Tip semestra je obavezan';
        }

        if (!semesterData.startDate) {
            errors.startDate = 'Datum početka je obavezan';
        }

        if (!semesterData.endDate) {
            errors.endDate = 'Datum završetka je obavezan';
        }

        if (semesterData.startDate && semesterData.endDate) {
            if (new Date(semesterData.startDate) >= new Date(semesterData.endDate)) {
                errors.endDate = 'Datum završetka mora biti nakon datuma početka';
            }
        }

        if (semesterData.earlyEnrollmentStartDate && semesterData.startDate) {
            if (new Date(semesterData.earlyEnrollmentStartDate) > new Date(semesterData.startDate)) {
                errors.earlyEnrollmentStartDate = 'Datum prijevremenog upisa mora biti prije početka semestra';
            }
        }

        return errors;
    };

    formatSemesterType(semesterType) {
        const typeMap = {
            'winter semester': 'Zimski semestar',
            'summer semester': 'Ljetni semestar'
        };
        return typeMap[semesterType] || semesterType;
    }



    formatDate(timestamp) {
        if (!timestamp) return '';
        return new Date(timestamp).toLocaleDateString('hr-HR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    getAcademicYearDropdownOptions() {
        const { academicYears } = this.state;
        return [...academicYears]
            .sort((a, b) => (b.startYear || b.id) - (a.startYear || a.id))
            .map(year => ({
                key: year.id,
                value: year.id,
                text: year.name
            }));
    }

    getSemesterTypeDropdownOptions() {
        const { semesterTypeOptions } = this.state;
        return semesterTypeOptions.map(type => ({
            key: type._key,
            value: type._key,
            text: this.formatSemesterType(type.name)
        }));
    }
}

export default SemesterManagement;



// WEBPACK FOOTER //
// ./src/views/Admin/SemesterManagement/SemesterManagement.js